/**
 * Stimpack Action
 *
 * @version: 1.0
*/

/*
target      : '',

// Action - Single ---------------------------------------------------------- //

action      : {
    attribute   : 'class',                  //
    value       : 'my_class',               //
    condition   : {}                        // Object:
},

// Action - Multiple -------------------------------------------------------- //

action      : [
    {
        attribute   : 'class',              // String:
        value       : 'my_class',           // String/Array:
    },
    {
        callback    : 'my_callback'         // String:
    },
    {
        callback    : 'my content',         // String:
        method      : 'replace'             // String: 'replace', 'append', 'prepend'
        wrap        : '',                   // String:
    }
},
],

// Trigger - Single --------------------------------------------------------- //

trigger     : {
    element     : [
        selector    : '.my_class',
        ancestor    : ['_target', 'div'],
    ],
    method      : 'one',
    event       : '',
    descendants : '',
    delay       : 0
},

// Trigger - Multiple ------------------------------------------------------- //

trigger     : [
    {...},
    {...},
],

// Condition - Single ------------------------------------------------------- //

condition   : {
    'value_a'   : [
        'selector'  : '.my_class',
        'ancestor'  : ['_target', 'form'],
        'attribute' : 'value'
    ],
    'operator'  : '!=',
    'value_b'   : 'United States',
},

// Condition - Multiple ----------------------------------------------------- //

condition   : {
    relation: 'AND',
    {
        test : ''
    },
    {
        test : ''
    }
}

*/

(function($, undefined) {

    var spAction = function(el, o)
    {
        var root = $(el);

        // Options ---------------------------------------------------------- //

        var _o = {
            target          : '',
            action          : null,
            trigger         : null,
            condition       : null,
            executeOnInit   : false
        };

        this.o = (typeof o === 'object') ? $.extend({}, _o, o) : _o;

        // Elements --------------------------------------------------------- //

        this.el = {
            target  : this.o.target ? $(this.o.target) : root,
        };

        this.init();

        return this;
    };

    // ---------------------------------------------------------------------- //
    //
    // ---------------------------------------------------------------------- //

    /**
     * Init
     */
    spAction.prototype.init = function()
    {
        var _t = this;

        // ------------------------------------------------------------------ //

        if (this.o.trigger)
        {
            if (Array.isArray(this.o.trigger))
            {
                $.each(this.o.trigger, function(i, o) {
                    _t.initTrigger(o);
                });
            }
            else
            {
                this.initTrigger(this.o.trigger);
            }
        }

        // ------------------------------------------------------------------ //

        if (this.o.condition)
        {
            this.initCondition(this.o.condition);
        }

        // ------------------------------------------------------------------ //

        if (!this.o.trigger || this.o.executeOnInit)
        {
            this.execute();
        }
    };

    // ---------------------------------------------------------------------- //
    // Trigger(s)
    // ---------------------------------------------------------------------- //

    /**
     * Init trigger
     */
    spAction.prototype.initTrigger = function(trigger)
    {
        var _t = this,
            el = _t.el.target;

        if (trigger.element)
        {
            if (typeof trigger.element === 'object' && trigger.element.ancestor && Array.isArray(trigger.element.ancestor) && '_target' === trigger.element.ancestor[0])
            {
                trigger.element.ancestor[0] = this.el.target;
            }

            el = spGetElement(trigger.element);
        }

        if (el.length > 0)
        {
            var _trigger = trigger;

            el[trigger.method ? trigger.method : 'on'](trigger.event, (trigger.descendants ? trigger.descendants : null), function() {

                if (_trigger.delay)
                {
                    setTimeout(function() {_t.execute();}, _trigger.delay);
                }
                else
                {
                    _t.execute();
                }
            });
        }
    };

    // ---------------------------------------------------------------------- //
    // Condition
    // ---------------------------------------------------------------------- //

    /**
     * Init condition
     */
    spAction.prototype.initCondition = function(condition)
    {
        var _t = this;

        if (typeof condition.relation !== 'undefined')
        {
            $.each(condition, function(i, rule) {
                _t.initCondition(rule);
            });
        }
        else
        {
            $.each(condition, function(i, property) {

                if (typeof property === 'object' && property.ancestor && Array.isArray(property.ancestor) && '_target' === property.ancestor[0])
                {
                    property.ancestor[0] = _t.el.target;
                }
            });
        }
    };

    // ---------------------------------------------------------------------- //
    // Execute
    // ---------------------------------------------------------------------- //

    /**
     * Execute
     */
    spAction.prototype.execute = function()
    {
        var _t = this,
            verified = _t.o.condition ? spVerifyCondition.call(this, _t.o.condition) : true; //$.extend({}, this.o.condition)

        if (Array.isArray(_t.o.action))
        {
            $.each(_t.o.action, function(i, action) {
                _t.executeAction(action, verified);
            });
        }
        else
        {
            _t.executeAction(_t.o.action, verified);
        }
    };

    /**
     * Execute action
     */
    spAction.prototype.executeAction = function(action, verified)
    {
        verified = action.condition ? spVerifyCondition.call(this, action.condition) : verified;

        if (typeof action === 'function')
        {
            action.call(this, verified);
        }
        else if (action.attribute)
        {
            this.updateAttribute(action.attribute, action.value, verified);
        }
        else if (action.html || action.append || action.prepend)
        {
            this.updateHtml(action, verified);
        }
    };


    // ---------------------------------------------------------------------- //
    //
    // ---------------------------------------------------------------------- //

    /**
     * Update attribute
     */
    spAction.prototype.updateAttribute = function(name, value, verified)
    {
        if ('class' === name)
        {
            if (Array.isArray(value))
            {
                this.el.target
                    .addClass(verified ? value[0] : value[1])
                    .removeClass(verified ? value[1] : value[0]);
            }
            else
            {
                this.el.target[verified ? 'addClass' : 'removeClass'](value);
            }
        }
        else
        {
            if (Array.isArray(value))
            {
                this.el.target.attr(name, verified ? value[0] : value[1]);
            }
            else
            {
                this.el.target[verified ? 'attr' : 'removeAttr'](name, value);
            }
        }
    };

    // ---------------------------------------------------------------------- //
    //
    // ---------------------------------------------------------------------- //

    spAction.prototype.updateHtml = function(o, verified)
    {
        // TODO add append, prepend

        if (spIsBase64(o.html))
        {
            o.html = spBase64Decode(o.html);
        }

        // TODO if wrap

        if (Array.isArray(o.html))
        {
            this.el.target.html(verified ? o.html[0] : o.html[1]);
        }
        else
        {
            this.el.target.html(verified ? o.html : '');
        }
    };

    // ---------------------------------------------------------------------- //
    // jQuery plugin
    // ---------------------------------------------------------------------- //

    $.fn.spAction = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-action');

            $(this).attr('data-sp-action', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, JSON.parse(spBase64Decode(_options)));
                }
            }

            this.spAction = new spAction(this, options);
        });
    };

    $('[data-sp-action]').each(function() {
        $(this).spAction();
    });

})(jQuery);
